import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of, Subject } from "rxjs";
import { map, shareReplay, take, tap } from "rxjs/operators";
import { Employee, EmployeeResponseObject } from "@ui-components/models";
import { DataSourcesService } from "./data-sources.service";

@Injectable({
  providedIn: "root",
})
export class EmployeesDataService {

  private employeesDataSubject = new BehaviorSubject<Employee[]>([]);
  employees$: Observable<Employee[]> = this.employeesDataSubject.asObservable();

  constructor(private http: HttpClient, private dataSourcesService: DataSourcesService) { }

  getEmployees(apiId) {
    let arr = [];

    this.employees$
      .pipe(take(1))
      .subscribe(
        (res) => arr = res
      );

    if (arr.length > 0) { return; }

    let data = {
      CompanyId: "1",
      PageNumber: "1",
      nBranch: "1",
      EmployeeStatus: "2",
      inputType: ["CompanyId", "PageNumber", "nBranch", "EmployeeStatus"],
    };

    this.dataSourcesService.invokeDataSource(apiId, data)
      .pipe(
        tap((res: EmployeeResponseObject) => {
          if (res.IsError) {
            console.log(res.ErrorMessage);
            return of({ Data: [] });
          }
        }),
        map((res: EmployeeResponseObject) => res.Data),
        map((data: Employee[]) =>
          data.map((e) => ({
            ...e,
            FL_NAME: this.getFLName(e.NAME),
          })) as Employee[]
        ),
        tap((res: Employee[]) => this.employeesDataSubject.next(res)),
        shareReplay(1)
      )
      .subscribe();
  }

  public getFLName(name) {
    var nameArray = [];
    nameArray = name.split(" ");
    return nameArray[0] + " " + nameArray[nameArray.length - 1];
  }
}
